import { apiAxios } from '../../../helpers/api'
import queueToast from '../../../helpers/queueToast'

export const setUpdate = async (one, url) => {
  const result = await apiAxios.put(url + one._id, one)
  queueToast(result.data.message.reason, 'success', 'warning')
}
export const setDelete = async (id, url) => {
  const result = await apiAxios.delete(url + id)
  queueToast(result.data.message.reason, 'success', 'warning')
}
export const setCreate = async (one, url) => {
  const result = await apiAxios.post(url + 'create/', one)
  queueToast(result.data.message.reason, 'success', 'warning')
}
